<template>
  <a-layout :class="['main-layout', device]" :style="{ display: 'flex', height: '100vh', flexDirection: 'column' }">
    <global-header v-if="showHeader" :mode="layoutMode" :theme="navTheme" :device="device" />
    <a-layout-content style="flex: 1; margin: 0; overflow: hidden; background: #fff;" :class="isShowRobot?'has-robot':''">
      <transition v-show="!microAppLoading" name="page-transition">
        <keep-alive><route-view /></keep-alive>
      </transition>
      <div v-show="!microAppLoading && !isHome" style="height: 100%;">
        <div
          v-for="app in appList"
          v-show="app.name === showMicroApp"
          :id="app.container.slice(1)"
          :key="app.name"
          class="app-container">
        </div>
      </div>
      <div v-if="isShowRobot" :class="isShowRobot?'robot_div':'robot_div_hidden'" class="robot_msg">
        <a-icon type="close" class="close-icon" @click="robotClick(false)" />
        <iframe v-if="iframe_url" id="iframe" ref="iframe" :src="iframe_url" width="100%" height="100%" frameborder=0 class="iframe"></iframe>
      </div>
      <div v-show="!isShowRobot && isCanShowRobot" id="robot_icon" class="robot_icon">
        <a-icon type="close-circle" class="close-circle" @click.stop="hiddenRobot()" />
      </div>
      <div v-show="microAppLoading" class="alt-loading" :style="`background-image: url(${loading})`"></div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { mixin, mixinDevice } from '@/utils/mixin'
import RouteView from './RouteView'
import GlobalHeader from '@/layouts/GlobalHeader/GlobalHeader'
import { queryStatus, init } from '@/api/login'
import { mapGetters } from 'vuex'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { config } from '@/microAppsConfig'

const loading = require('@/assets/images/loading.gif')

export default {
  name: 'CommonLayout',
  mixins: [mixin, mixinDevice],
  components: {
    RouteView,
    GlobalHeader
  },
  data () {
    return {
      loading,
      appList: config,
      render: false,
      isFirst: false,
      isShowRobot: false,
      isMove: false
    }
  },
  computed: {
    ...mapGetters(['microAppLoading', 'showMicroApp', 'showRobotIcon', 'mobile', 'hasAgent']),
    contentPaddingLeft () {
      if (this.sidebarOpened) {
        return '168px'
      }
      return '58px'
    },
    showHeader () {
      const currentPath = this.$route.path.substring(1, 6)
      return currentPath !== 'login' && this.render
    },
    isCanShowRobot () {
      const path = this.$route.fullPath
      return !path.includes('/login/page') && // 登录页不显示
              !path.includes('agent/multiAgent/manage/edit') && // 智能体编辑页面不显示
              this.showRobotIcon && // 主动关闭的不显示
              this.hasAgent // 是否有智能体
    },
    iframe_url () {
      const bases = {
        dev: 'https://dev-ai.wehichina.com/m/chatIndex',
        test: 'https://test-ai.wehichina.com/m/chatIndex',
        pre: 'https://pre-ai.wehichina.com/m/chatIndex',
        pro: 'https://ai.wehichina.com/m/chatIndex'
      }
      const token = this.$cookie.get(ACCESS_TOKEN)
      const env = process.env.VUE_APP_ENV || 'pro'
      const baseURL = (bases[env] ? bases[env] : bases.pro) + `?from=pc&sourceFlag=QIAO_CAI&token=${token}&sourceEnv=1`
      return baseURL
    },
    isHome () {
      return this.$route.path.includes('main_home')
    }
  },
  mounted () {
    // 延时进行数据初始化，避免登录页面的时候超前初始化
    setTimeout(() => {
      if (this.showHeader) this.initTenantData()
    }, 500)
    // 避免头部工具条在登录也闪烁的问题
    setTimeout(() => { this.render = true }, 1)
    this.setDragIcon()
  },
  methods: {
    judgeStatus() {
      return queryStatus().then(res => {
        const data = res.data
        return Boolean(data && data.success)
      }).catch(() => {
        // this.Logout()
      })
    },
    initTenantData () {
      const that = this
      const { $message } = that
      const { judgeStatus } = this
      return judgeStatus().then(status => {
        if (!status) {
          return init().then(res => {
            const { data } = res
            if (data && data.success) {
              return true
            } else {
              const msg = data.msg || '初始化租户信息失败'
              $message.error(msg)
              throw (new Error(msg))
            }
          })
        }
        return true
      }).catch(() => {
        // this.Logout()
      })
    },
    robotClick (falg = false) {
      this.isShowRobot = falg
    },
    hiddenRobot() {
      this.isShowRobot = false
      this.$store.commit('setShowRoobtIcon', false)
      localStorage.setItem(`${this.mobile}_showRobotIcon`, '0')
    },
    setDragIcon () {
      const robotIcon = document.querySelector('.robot_icon')
      const main = document.querySelector('.main-layout')
      robotIcon.onmousedown = null
      this.isMove = true
      robotIcon.onmousedown = (e) => {
        // 计数
        this.addIndex += 1
        const x = e.clientX - robotIcon.offsetLeft
        const y = e.clientY - robotIcon.offsetTop
        const pos = main.getBoundingClientRect()
        this.isMove = false
        document.onmousemove = (e) => {
          let left = e.clientX - x
          let top = e.clientY - y
          if (left < 0) {
            left = 0
          }
          if (top < 0) {
            top = 0
          }
          if (left > pos.width - robotIcon.offsetWidth) {
            left = pos.width - robotIcon.offsetWidth
          }
          if (top > pos.height - robotIcon.offsetHeight) {
            top = pos.height - robotIcon.offsetHeight
          }
          robotIcon.style.left = left + 'px'
          robotIcon.style.top = top + 'px'
          this.isMove = true
        }
        document.onmouseup = () => {
          document.onmousemove = null
          document.onmouseup = null
          if (!this.isMove) {
            this.isShowRobot = true
          }
        }
      }
    }
  }
}
</script>

<style lang="less">
.page-transition-enter {
  opacity: 0;
}
.page-transition-leave-active {
  opacity: 0;
}
.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.alt-loading {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80px;
}
.app-container {
  height: 100%;
  overflow-x: auto;
  &>div {
    height: 100%;
    position: relative;
    min-width: 1440px;
  }
}
// 清空管理报表和合并报表的宽度限制
#container_report, #container_crs {
  &>div {
    min-width: auto!important;
  }
}
.ant-layout-content {
  position: relative;
  &.has-robot {
    padding-right: 370px;
  }
  .robot_msg {
    width: 370px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9999;
    .close-icon {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
      font-size: 20px;
    }
  }
  .robot_icon {
    background: url('../assets/images/lingxin.gif');
    background-position: center center; /* 水平居中和垂直居中 */
    background-size: 125.49px 80px; /* 背景图片覆盖整个元素区域 */
    background-repeat: no-repeat; /* 不重复背景图片 */
    position: absolute;
    cursor: pointer;
    bottom: 80px;
    right: 10px;
    width:150px;
    height:80px;
    z-index: 100000;
    .close-circle {
      font-size: 16px;
      position: absolute;
      top: -10px;
      right: 20px;
    }
  }
}

</style>
